const DichiarazioneIntegrativaObbligatorietaProtocollo = {
    // / <summary>
    // / Dichiarazione annullata
    // / </summary>
    NonRichiesto: 0,

    // / <summary>
    // /     Dichiarazione dell'anno precedente
    // / </summary>
    Facoltativo: 1,

    // / <summary>
    // /     Dichiarazione senza errori ma non ancora completata
    // / </summary>
    Obbligatorio: 2,
};

export default DichiarazioneIntegrativaObbligatorietaProtocollo;
